import React from "react";
import useStore from "../../../../context/useStore";
import useRole from "../../../../hooks/useRole/useRole";
import useLeadAutoFilters from "./useLeadAutoFilters";
import { LEAD_AUTO_PRESETS, QUICK_STATUSES } from "./leadAutoPresets";

const LeadAutoQuickFilterBar = ({
  showAdvanced,
  onToggleAdvanced,
  activeFilterCount,
  isLoading,
}) => {
  const [state] = useStore();
  const { myRole } = useRole();
  const { LEAD_STATUS } = state.constants.items;
  const userId = state.auth?.user?.id;
  const { leadAutoFilters, actions } = useLeadAutoFilters();
  const { terms, statuses } = leadAutoFilters;

  const presetCtx = { userId, myRole, LEAD_STATUS };
  const availablePresets = LEAD_AUTO_PRESETS.filter((p) => p.isAvailable(presetCtx));

  // Statut rapide : un clic = ce seul statut actif (toggle off si déjà seul
  // actif), recherche immédiate.
  const quickStatuses = QUICK_STATUSES.filter((qs) =>
    LEAD_STATUS.some((s) => s.id === qs.id),
  );
  const isQuickStatusOn = (id) => statuses.length === 1 && statuses[0] === id;
  const onQuickStatus = (id) =>
    actions.applyAndSearch({ statuses: isQuickStatusOn(id) ? [] : [id] });

  return (
    <>
      <div className="lf-toolbar">
        {quickStatuses.length > 0 && (
          <div className="lf-seg" role="group" aria-label="Statut rapide">
            {quickStatuses.map((qs) => (
              <button
                key={qs.id}
                type="button"
                className={isQuickStatusOn(qs.id) ? "lf-on" : ""}
                aria-pressed={isQuickStatusOn(qs.id)}
                onClick={() => onQuickStatus(qs.id)}
              >
                <i className={`fa ${qs.icon}`} />
                {qs.label}
              </button>
            ))}
          </div>
        )}

        <div className="lf-search">
          <i className="fa fa-search" />
          <input
            type="text"
            value={terms}
            placeholder="Email, téléphone, nom ou prénom…"
            aria-label="Recherche par email, téléphone, nom ou prénom"
            onChange={(e) => actions.updateFilter("terms", e.target.value)}
          />
        </div>

        <button
          type="button"
          className={
            "lf-btn lf-btn-ghost" + (activeFilterCount > 0 ? " lf-badge-on" : "")
          }
          onClick={onToggleAdvanced}
          aria-expanded={showAdvanced}
        >
          <i className="fa fa-sliders" />
          Filtres
          {activeFilterCount > 0 && (
            <span className="lf-count">{activeFilterCount}</span>
          )}
        </button>

        <button
          type="submit"
          className="lf-btn lf-btn-primary"
          disabled={isLoading}
        >
          <i className={isLoading ? "fa fa-spinner fa-spin" : "fa fa-search"} />
          Rechercher
        </button>
      </div>

      {availablePresets.length > 0 && (
        <div className="lf-presets">
          <span className="lf-lbl">Vues rapides</span>
          {availablePresets.map((preset) => {
            const on = actions.isPresetOn(preset, presetCtx);
            return (
              <button
                key={preset.id}
                type="button"
                className={"lf-chip" + (on ? " lf-on" : "")}
                aria-pressed={on}
                onClick={() => actions.applyPreset(preset, presetCtx)}
              >
                <i className={`fa ${preset.icon}`} />
                {preset.label}
              </button>
            );
          })}
        </div>
      )}
    </>
  );
};

export default LeadAutoQuickFilterBar;
